import api from '../../utils/api';
import { SectorItem, SectorPermission } from './settings.types';

const STORAGE_KEY = 'mc_sectors_config';

const DEFAULT_PERMISSIONS_ALL_TRUE: SectorPermission = {
  view: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
  add: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
  edit: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
  delete: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
  export: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
};

const DEFAULT_PERMISSIONS_NORMAL: SectorPermission = {
  view: { pedido: true, produto: true, categoria: true, status: true, usuario: false, setor: false, configuracao: false, relatorios: true },
  add: { pedido: true, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
  edit: { pedido: true, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
  delete: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
  export: { pedido: true, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: true },
};

// 8 Setores reais e oficiais configurados na tabela `sectors` do banco de dados MySQL
export const INITIAL_SECTORS: SectorItem[] = [
  {
    id: '01',
    name: 'Corte',
    colorHex: '#0d6efd',
    orderIndex: 1,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '02',
    name: 'Dobra',
    colorHex: '#fd7e14',
    orderIndex: 2,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '03',
    name: 'Solda',
    colorHex: '#0d6efd',
    orderIndex: 3,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '04',
    name: 'Acabamento',
    colorHex: '#198754',
    orderIndex: 4,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '05',
    name: 'Acessórios',
    colorHex: '#0dcaf0',
    orderIndex: 5,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: true, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '06',
    name: 'Embalagem',
    colorHex: '#6c757d',
    orderIndex: 6,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '07',
    name: 'Logística',
    colorHex: '#6c757d',
    orderIndex: 7,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
  {
    id: '08',
    name: 'Instalação',
    colorHex: '#6c757d',
    orderIndex: 8,
    isProductionSequence: true,
    status: 'ATIVO',
    permissions: {
      ...JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL)),
      view: { pedido: true, produto: true, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: true, produto: false, categoria: false, status: true, usuario: false, setor: false, configuracao: false, relatorios: false },
    },
  },
];

export class SettingsController {
  static getSectors(): SectorItem[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (!data) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_SECTORS));
        return INITIAL_SECTORS;
      }
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed) && parsed.length > 0) {
        // Validação de sanidade: se contiver 'Vendas' que era do mock antigo, substitui
        const hasLegacy = parsed.some(s => s.name === 'Vendas');
        if (hasLegacy) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_SECTORS));
          return INITIAL_SECTORS;
        }
        return parsed;
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_SECTORS));
      return INITIAL_SECTORS;
    } catch {
      return INITIAL_SECTORS;
    }
  }

  static async getSectorsFromServer(): Promise<SectorItem[]> {
    try {
      const response = await api.get('/sectors');
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const formattedList: SectorItem[] = response.data.map((item: any, idx: number) => {
          const rawId = item.id ? String(item.id) : String(idx + 1);
          const formattedId = rawId.length === 1 ? rawId.padStart(2, '0') : rawId;
          
          let permissions = item.permissions;
          if (typeof permissions === 'string') {
            try {
              permissions = JSON.parse(permissions);
            } catch {
              permissions = null;
            }
          }
          if (!permissions || !permissions.view) {
            permissions = JSON.parse(JSON.stringify(DEFAULT_PERMISSIONS_NORMAL));
          }

          const isProd = item.is_production_sequence !== undefined 
            ? Boolean(item.is_production_sequence) 
            : (item.isProductionSequence !== undefined ? Boolean(item.isProductionSequence) : true);

          return {
            id: formattedId,
            name: item.name,
            colorHex: item.color_hex || item.colorHex || '#0d6efd',
            orderIndex: item.order_index ?? item.orderIndex ?? (idx + 1),
            isProductionSequence: isProd,
            status: item.status || 'ATIVO',
            permissions: permissions
          };
        });

        localStorage.setItem(STORAGE_KEY, JSON.stringify(formattedList));
        return formattedList;
      }
    } catch (e) {
      console.warn("Could not load sectors from /sectors endpoint, trying fallback /system-settings.", e);
      try {
        const response = await api.get('/system-settings?key=sectors_config');
        if (response.data && response.data.value) {
          const parsed = JSON.parse(response.data.value);
          if (Array.isArray(parsed) && parsed.length > 0) {
            const hasLegacy = parsed.some(s => s.name === 'Vendas');
            if (!hasLegacy) {
              localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
              return parsed;
            }
          }
        }
      } catch {}
    }

    const local = this.getSectors();
    return local;
  }

  static saveSector(
    id: string | null, 
    name: string, 
    permissions: SectorPermission, 
    colorHex = '#0d6efd', 
    isProductionSequence = true, 
    orderIndex?: number
  ): SectorItem[] {
    const list = this.getSectors();
    if (id) {
      const index = list.findIndex(s => s.id === id);
      if (index !== -1) {
        list[index].name = name;
        list[index].permissions = permissions;
        list[index].colorHex = colorHex;
        list[index].isProductionSequence = isProductionSequence;
        if (orderIndex !== undefined) {
          list[index].orderIndex = orderIndex;
        }
      }
    } else {
      const nextId = String(Math.max(...list.map(s => parseInt(s.id) || 0), 0) + 1).padStart(2, '0');
      const maxOrder = Math.max(...list.map(s => s.orderIndex || 0), 0) + 1;
      list.push({
        id: nextId,
        name,
        colorHex,
        orderIndex: orderIndex !== undefined ? orderIndex : maxOrder,
        isProductionSequence,
        status: 'ATIVO',
        permissions,
      });
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    return list;
  }

  static async saveSectorToServer(
    id: string | null, 
    name: string, 
    permissions: SectorPermission, 
    colorHex = '#0d6efd', 
    isProductionSequence = true, 
    orderIndex?: number
  ): Promise<SectorItem[]> {
    let numericId = id ? parseInt(id, 10) : null;
    if (isNaN(numericId as any)) numericId = null;

    try {
      await api.post('/sectors', {
        id: numericId,
        name,
        color_hex: colorHex,
        colorHex: colorHex,
        is_production_sequence: isProductionSequence,
        isProductionSequence: isProductionSequence,
        order_index: orderIndex,
        orderIndex: orderIndex,
        permissions
      });
    } catch (e) {
      console.error("Failed saving sector via /sectors endpoint", e);
      try {
        const list = this.saveSector(id, name, permissions, colorHex, isProductionSequence, orderIndex);
        await api.post('/system-settings', { key: 'sectors_config', value: list });
      } catch {}
    }

    return this.getSectorsFromServer();
  }

  static deleteSector(id: string): SectorItem[] {
    let list = this.getSectors();
    list = list.filter(s => s.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    return list;
  }

  static async deleteSectorFromServer(id: string): Promise<SectorItem[]> {
    const numericId = parseInt(id, 10);
    try {
      await api.post('/sectors/delete', { id: numericId || id });
    } catch (e) {
      console.error("Failed deleting sector via /sectors/delete endpoint", e);
    }
    return this.getSectorsFromServer();
  }

  static getEmptyPermissions(): SectorPermission {
    return {
      view: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
      add: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
      edit: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
      delete: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
      export: { pedido: false, produto: false, categoria: false, status: false, usuario: false, setor: false, configuracao: false, relatorios: false },
    };
  }

  static getFullPermissions(): SectorPermission {
    return {
      view: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
      add: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
      edit: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
      delete: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
      export: { pedido: true, produto: true, categoria: true, status: true, usuario: true, setor: true, configuracao: true, relatorios: true },
    };
  }
}

